import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try {
        const { data } = await api.post("/auth/refresh");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    load();
    const onExpired = () => setUser(false);
    window.addEventListener("auth-expired", onExpired);
    return () => window.removeEventListener("auth-expired", onExpired);
  }, [load]);

  useEffect(() => {
    if (!user) return undefined;
    const id = setInterval(() => api.post("/auth/refresh").catch(() => {}), 10 * 60 * 1000);
    return () => clearInterval(id);
  }, [user]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  const can = (p) => !!user && (user.role === "owner" || !!user.permissions?.[p]);
  const isStaff = !!user && user.role !== "crew";
  return <Ctx.Provider value={{ user, setUser, logout, can, isStaff, reload: load }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
